import { takeEvery } from 'redux-saga/effects';

import * as extrasActions from 'store/modules/extras';
import { addExtra } from './utils';

export default function* listenAddExtra() {
  yield takeEvery(extrasActions.addExtra.toString(), addExtra);
}
